import Vue from 'vue';
import axios from 'axios';
// import VeeValidate from 'vee-validate';
import VueHotkey from 'v-hotkey';
import VueScrollTo from 'vue-scrollto';

import mixpanel from '@/plugins/mixpanel';

// Chartjs plugins hack for using datalabels plugin locally
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Styles
import './styles/main.scss';

import JsonViewer from 'vue-json-viewer';
import { VueHammer } from 'vue2-hammer'; // Hammerjs: touch gestures framework
import VueMask from 'v-mask'; // Input formatter
import VueMeta from 'vue-meta';

// Custom directives
import MultiClick from '@/_utilities/MultiClick';
import Scrollable from '@/_utilities/Scrollable';
import DragScroll from '@/_utilities/DragScroll';
import '@/_utilities/ClickOutside';

import '@/_utilities/ResponsiveImage';
// Google login
import GAuth from 'vue-google-oauth2';

import { API_ROOT, GOOGLE_CLIENT_ID } from './config';
import App from './App';
import utilsMixin from './_utilities/utilsMixin';
import textMixins from './_utilities/textMixins';
import helpers from './helpers';
import { store } from './_store';
import router from './_router';

// UI
import './components';
import './components/Base';
import './layouts';
import './vee-validate';
import i18n from './plugins/i18n';
import { fontAwesomeInit } from './fontawesome';
import { bootstrapInit } from './bootstrap';

Vue.prototype.$mixpanel = mixpanel;
Vue.use(VueMeta);

fontAwesomeInit();

Chart.plugins.unregister(ChartDataLabels);

const moment = require('moment-timezone');

moment.locale('en');
moment.updateLocale('en', {
  monthsShort: [
    'Jan',
    'Feb',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ],
});

Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.$moment = moment;
Vue.prototype.api_root = API_ROOT;

Vue.prototype.longdateformat = 'dddd, MMM Do h:mm a';
Vue.prototype.dateformat = 'LLL';
Vue.prototype.openInNewTab = (url) => {
  if (url === null || url === undefined || url.length === 0) return;
  window.open(url, '_blank');
};
Vue.prototype.user = () => JSON.parse(localStorage.getItem('user'));

bootstrapInit();

Vue.use(helpers);
Vue.use(VueHotkey);
Vue.use(VueScrollTo);

Vue.mixin(textMixins);
Vue.mixin(utilsMixin);

// Import JsonViewer as a Vue.js plugin
Vue.use(JsonViewer);

Vue.use(VueMask);

VueHammer.config.press = {
  threshold: 1000,
};

Vue.use(VueHammer);

Vue.directive('multiclick', MultiClick);
Vue.directive('scrollable', Scrollable);
Vue.directive('drag-scroll', DragScroll);

Vue.filter('formatSize', (size) => {
  if (size > 1024 * 1024 * 1024 * 1024) {
    return `${(size / 1024 / 1024 / 1024 / 1024).toFixed(2)} TB`;
  }
  if (size > 1024 * 1024 * 1024) {
    return `${(size / 1024 / 1024 / 1024).toFixed(2)} GB`;
  }
  if (size > 1024 * 1024) {
    return `${(size / 1024 / 1024).toFixed(2)} MB`;
  }
  if (size > 1024) {
    return `${(size / 1024).toFixed(2)} KB`;
  }
  return `${size.toString()} B`;
});

Vue.filter('urlid', (url) => {
  const ctx = 'urlid';
  const cleanUrl = url.toLowerCase().replace(/:\/\.\?&/, '_');
  return `${ctx}_${cleanUrl}`;
});

// matches stylelab-backend/stylelab/api/gmail_sender.py
const googleScopes = ['https://www.googleapis.com/auth/gmail.send'];
const gauthOption = {
  clientId: GOOGLE_CLIENT_ID,
  scope: googleScopes.join(' '),
  prompt: 'consent',
};
Vue.use(GAuth, gauthOption);
// console.log(`Google client is ${GOOGLE_CLIENT_ID}`);

new Vue({
  i18n,
  store,
  render: (h) => h(App),
  router,
}).$mount('#app');

// Prototypes
if (!Array.prototype.last) {
  // eslint-disable-next-line
  Array.prototype.last = function () {
    return this[this.length - 1];
  };
}

if (!String.prototype.isEmail) {
  // eslint-disable-next-line
  String.prototype.isEmail = function () {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this);
  };
}

if (!String.prototype.striphtml) {
  // eslint-disable-next-line
  String.prototype.striphtml = function () {
    const node = document.createElement('div');
    node.innerHTML = this;
    const content = node.textContent;
    return content;
  };
}

// eslint-disable-next-line
window.Clipboard = (function (window, document, navigator) {
  let textArea;
  let copy;

  function isOS() {
    return navigator.userAgent.match(/ipad|iphone/i);
  }

  function createTextArea(text) {
    textArea = document.createElement('textArea');
    textArea.value = text;
    document.body.appendChild(textArea);
  }

  function selectText() {
    let range;
    let selection;

    if (isOS()) {
      range = document.createRange();
      range.selectNodeContents(textArea);
      selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      textArea.setSelectionRange(0, 999999);
    } else {
      textArea.select();
    }
  }

  function copyToClipboard() {
    document.execCommand('copy');
    document.body.removeChild(textArea);
  }
  // eslint-disable-next-line
  copy = function (text) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text);
    } else {
      createTextArea(text);
      selectText();
      copyToClipboard();
    }
  };

  return {
    copy,
  };
})(window, document, navigator);

store.dispatch('account/refresh');
